var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline"},[_c('a',{attrs:{"href":_vm.mailTo,"target":"_blank"}},[_c('span',{staticClass:"theEmail pb-1"},[_vm._v("Email")])])])}
var staticRenderFns = []

export { render, staticRenderFns }